import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, isBootstrapped } = useSelector((state) => state.auth);

  // Wait until we've checked the session at least once
  if (!isBootstrapped) {
    return null; // App.jsx splash screen handles this, but null here is safe
  }

  // Only redirect if we ARE bootstrapped (check finished) and NOT authenticated
  if (!isAuthenticated && !isLoading) {
    return <Navigate to="/login" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;
